import { useEffect, useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { INSIGHT_EN, INSIGHT_SK } from '../utils/constants/insight_constants.js';

const useSecondaryActions = () => {
  const [disabledStates, setFormDisabledStates] = useState(undefined);
  const [visibleElement, setVisibleElement] = useState(undefined);
  const [secondaryActions, setSecondaryActions] = useState([]);
  const { t } = useTranslation();

  const INACCESSIBLE_OVERVIEW = t(
    'Náhľad nedostupný, musíte vyplniť názov a obsah!',
  );
  const SHOW_VERSION_SK = t('Zobraziť slovenský náhľad');
  const SHOW_VERSION_EN = t('Zobraziť anglický náhľad');

  const getItem = (isDisabled, versionMessage, insights) => {
    return isDisabled === true
      ? {
          title: t(versionMessage),
          icon: <EyeOutlined />,
          disabled: true,
          tooltip: t(INACCESSIBLE_OVERVIEW),
          showDisabledMessage: false,
        }
      : {
          onClick: () => setVisibleElement(insights),
          title: t(versionMessage),
          icon: <EyeOutlined />,
        };
  };
  useEffect(() => {
    const secondaryActionsArr = [
      getItem(disabledStates?.sk, SHOW_VERSION_SK, INSIGHT_SK),
      getItem(disabledStates?.en, SHOW_VERSION_EN, INSIGHT_EN),
    ];

    setSecondaryActions(secondaryActionsArr);
  }, [disabledStates]);

  return {
    secondaryActions,
    setFormDisabledStates,
    visibleElement,
    setVisibleElement,
  };
};

export default useSecondaryActions;
